const WIDGET_ID = "989712cc-9885-4fd1-96e1-636c88b3f051";

export const initializeMessageBirdChat = (userId, userEmail) => {
  let script = document.createElement("script");
  script.type = "text/javascript";
  script.charset = "UTF-8";
  script.setAttribute("id", "messagebird-script");

  // Would recommend using a separate JS file to format this so it stays somewhat readable
  script.text = `
// The following is straight from the MessageBird docs but with Prettier formatting
var MessageBirdChatWidgetSettings = {
  widgetId: "${WIDGET_ID}",
  initializeOnLoad: true
};

!(function() {
  "use strict";
  if (Boolean(document.getElementById("live-chat-widget-script")))
    console.error("MessageBirdChatWidget: Snippet loaded twice on page");
  else {
    var e, t;
    (window.MessageBirdChatWidget = {}),
      (window.MessageBirdChatWidget.queue = []);
    for (
      var i = [
          "init",
          "setConfig",
          "toggleChat",
          "identify",
          "hide",
          "on",
          "shutdown",
          "logout"
        ],
        n = function() {
          var e = i[d];
          window.MessageBirdChatWidget[e] = function() {
            for (var t = arguments.length, i = new Array(t), n = 0; n < t; n++)
              i[n] = arguments[n];
            window.MessageBirdChatWidget.queue.push([[e, i]]);
          };
        },
        d = 0;
      d < i.length;
      d++
    )
      n();
    var a =
        (null === (e = window) ||
        void 0 === e ||
        null === (t = e.MessageBirdChatWidgetSettings) ||
        void 0 === t
          ? void 0
          : t.widgetId) || "",
      o = function() {
        var e,
          t = document.createElement("script");
        (t.type = "text/javascript"),
          (t.src = "https://livechat.messagebird.com/bootstrap.js?widgetId=".concat(
            a
          )),
          (t.async = !0),
          (t.id = "live-chat-widget-script");
        var i = document.getElementsByTagName("script")[0];
        null == i ||
          null === (e = i.parentNode) ||
          void 0 === e ||
          e.insertBefore(t, i);
      };
    "complete" === document.readyState
      ? o()
      : window.attachEvent
      ? window.attachEvent("onload", o)
      : window.addEventListener("load", o, !1);

    // This is where we do our custom identification work to avoid previous user's conversations being seen
    var userId = "${userId}";
    var userEmail = "${userEmail}";
    // This will replace any special characters with an underscore as MessageBird crashes on any special characters that aren't @ . - or _
    var sanitizedEmail = userEmail.replace(/[^A-Za-z0-9@._-]/g, "_");

    // Ensures that identification only runs when the widget is ready
    window.MessageBirdChatWidget.on("ready", function() {
      // Identify regardless, logging out first causes some race condition / cascade issue in identification
      // Tried to fix this with promises, booleans, and catching identification events, but it didn't work
      // This method ensures that only the currently identified user is identified - for now anyway :shrug:
      window.MessageBirdChatWidget.identify(userId + "_" + sanitizedEmail)
        .then(function() {})
        .catch(function() {
          console.error("MessageBird identify failed");
          // If a user's identification fails, we log them out as it will revert back to whatever the last user was
          window.MessageBirdChatWidget.logout()
          .then(function() {})
          .catch(function() {
            console.error("MessageBird logout failed");
          });
        });
    });
  }
})();
  `;

  document.head.appendChild(script);
};
